define([
        'moment',
        'core/browser-storage',
        'air-datepicker',
        'air-datepicker/locale/en',

    ],
    function (
        moment, 
        browser_storage, 
        AirDatepicker,
        localeEn
    ) {
        let backingComponent = null;
        let presetsBuilt = false;
        let dateSelection = document.querySelector('#datepicker');
        let datepickerWrap = document.querySelector('.datepicker-wrap');
        let selectingPreset = false;
        // calling backingComponent.selectDate[x,x] fires onSelect event twice
        // this counter helps us ignore the first event
        let selectDateLoopCounter = 0;
        let fromText = '';

        let selection = {
            preset: 'Last 90 days',
            start: moment().subtract(90, 'days'),
            end: moment()
        };

        const presets = [
            {
                label: 'Today',
                start: moment(),
                end: moment()
            },
            {
                label: 'Yesterday',
                start: moment().subtract(1, 'days'),
                end: moment().subtract(1, 'days')
            },
            {
                label: 'Last 30 days',
                start: moment().subtract(30, 'days'),
                end: moment()
            },
            {
                label: 'Last 90 days',
                start: moment().subtract(90, 'days'),
                end: moment()
            },
            {
                label: 'This week',
                start: moment().startOf('week'),
                end: moment().endOf('week')
            },
            {
                label: 'Last week',
                start: moment().subtract(1, 'week').startOf('week'),
                end: moment().subtract(1, 'week').endOf('week')
            },
            {
                label: 'This month',
                start: moment().startOf('month'),
                end: moment().endOf('month')
            },
            {
                label: 'Last month',
                start: moment().subtract(1, 'month').startOf('month'),
                end: moment().subtract(1, 'month').endOf('month')
            },
            {
                label: 'This quarter',
                start: moment().startOf('quarter'),
                end: moment().endOf('quarter')
            },
            {
                label: 'Last quarter',
                start: moment().subtract(1, 'quarter').startOf('quarter'),
                end: moment().subtract(1, 'quarter').endOf('quarter')
            },
            {
                label: 'This year',
                start: moment().startOf('year'),
                end: moment().endOf('year')
            },
            {
                label: 'Last year',
                start: moment().subtract(1, 'year').startOf('year'),
                end: moment().subtract(1, 'year').endOf('year')
            },
            {
                label: 'All time',
                start: moment(globals.created_on),
                end: moment()
            }
        ];

        const keepDatePickerInView = () => {
            const calendar = document.querySelector('.calendar-presets-wrap');
            const calendarRect = calendar.getBoundingClientRect();
            const wrapper = document.querySelector('.datepicker-wrap');
            const wrapperRect = wrapper.getBoundingClientRect();
            
            const viewportWidth = window.innerWidth;
            const padding = 20;
            const mobileBreakpoint = 768;

            let wrapperLeft = wrapperRect.left;
            let newLeft = wrapperRect.left;
            let applyChange = false;

            // Check for horizontal overflow
            if (((calendarRect.right + padding) > viewportWidth) && (viewportWidth > mobileBreakpoint)) {
                newLeft = viewportWidth - wrapperLeft - calendarRect.width - padding;
                applyChange = true;
            } else if (wrapperLeft + calendarRect.width + padding < viewportWidth) {
                newLeft = 0;
                applyChange = true
            } else if (viewportWidth <= mobileBreakpoint && calendarRect.left > padding) {
                newLeft = (calendarRect.left - padding) * -1;
                applyChange = true;
            }

            // Apply the new position
            if (applyChange) {
                calendar.style.left = `${newLeft}px`;
            }
        }

        const enablePreset = (preset) => {
            backingComponent.clear({silent: true});

            // helps identify that we are selecting a preset option within onSelect event
            selectingPreset = true;
            selectDateLoopCounter = 0;

            // disable any currently active preset
            let selectedPreset = document.querySelector('.preset-option.active');
            if(selectedPreset) selectedPreset.classList.remove('active');

            let element = document.querySelector(`.preset-option[data-preset="${preset}"]`);
            element.classList.add('active');
            let startDate = element.getAttribute('data-start');
            let endDate = element.getAttribute('data-end');

            backingComponent.selectDate([startDate, endDate]);
            selection.preset = preset;
            selection.start = moment(startDate);
            selection.end = moment(endDate);
            backingComponent.setViewDate(endDate);
        }

        const initializePresetsAndWrapper = () => {
            const presetOptions = presets.map(preset => {
                let activeClass = selection.preset === preset.label ? 'active' : '';
                return `
                    <div class="preset-option ${activeClass}" data-preset="${preset.label}" data-start="${preset.start.format('YYYY-MM-DD')}" data-end="${preset.end.format('YYYY-MM-DD')}">
                        <h3>${preset.label}</h3>
                        <div class="date-range">${preset.start.format('MM/DD/YY')} - ${preset.end.format('MM/DD/YY')}</div>
                    </div>
                `;
            });

            let calendarAndPresetWrap = document.createElement('div');
            calendarAndPresetWrap.classList.add('calendar-presets-wrap');

            let presetContainer = document.createElement('div');
            presetContainer.classList.add('preset-options-wrap');

            let mobileToggle = document.createElement('div');
            mobileToggle.classList.add('preset-mobile-toggle');
            mobileToggle.innerText = 'Show presets';

            let datepickerElement = document.querySelector(".air-datepicker");
            
            presetContainer.innerHTML = presetOptions.join('');

            calendarAndPresetWrap.appendChild(datepickerElement);
            calendarAndPresetWrap.appendChild(presetContainer);
            calendarAndPresetWrap.appendChild(mobileToggle);
            
            datepickerWrap.appendChild(calendarAndPresetWrap);

            // set default date range
            dateSelection.innerText = `${fromText} ${selection.preset}`;

            presetsBuilt = true;

            window.addEventListener('resize', () => keepDatePickerInView());

            // show/hide calendar and preset options
            document.addEventListener('click', (event) => {
                const withinBoundaries = event.composedPath().includes(dateSelection) || event.composedPath().includes(calendarAndPresetWrap);
                const isActive = datepickerWrap.classList.contains('active');
                const isToggle = event.target.id === 'datepicker';

                if (withinBoundaries) {
                    if(isToggle && isActive) { 
                        datepickerWrap.classList.remove('active');
                    } else {
                        datepickerWrap.classList.add('active');
                        keepDatePickerInView();
                    }
                } else {
                    if(isActive) {
                        datepickerWrap.classList.remove('active');            
                    }
                }
            })

            // add event listeners to preset options
            presetContainer.querySelectorAll('.preset-option').forEach(option => {
                option.addEventListener('click', (e) => {
                    enablePreset(option.dataset.preset);
                });
            });

            mobileToggle.addEventListener('click', () => {
                datepickerWrap.classList.toggle('show-presets-mobile');
                mobileToggle.innerText = datepickerWrap.classList.contains('show-presets-mobile') ? 'Show calendar' : 'Show presets';
            })
        };

        let create = (onChange, includeFrom) => {
            if(includeFrom) fromText = 'From';

            const AirDatepickerConstructor = AirDatepicker.default || AirDatepicker; 
            backingComponent = new AirDatepickerConstructor("#datepicker", {
                inline: true,
                classes: "toggle",
                range: true,
                dynamicRange: false,
                fixedHeight: true,
                navTitles: {
                    days: 'MMMM yyyy'
                },
                locale: {
                    ...localeEn.default,
                    daysMin: ["S", "M", "T", "W", "T", "F", "S"]
                },
                dateFormat: "yyyy-MM-dd",
                startDate: moment(),
                selectedDates: [selection.start.format('YYYY-MM-DD'), selection.end.format('YYYY-MM-DD')],
                toggleSelected(data) {
                    // this allows users to select the same start and end date, without toggling the selection off
                    if (data.datepicker.selectedDates.length < 2) {
                        data.datepicker.selectDate([data.date, data.date]);
                        return false;
                    }

                    return true;
                },
                onRenderCell({ date }) {
                    if(!presetsBuilt) initializePresetsAndWrapper();
                },
                onSelect: (data) => {
                    if(data.date.length === 2 && selectDateLoopCounter > 0) {
                        
                        selection.start = moment(data.date[0])
                        selection.end = moment(data.date[1]);

                        // show selected preset if dates match
                        if(selectingPreset === true) {
                            presets.forEach(preset => {
                                if(preset.start.isSame(moment(data.date[0]), 'day') && 
                                    preset.end.isSame(moment(data.date[1]), 'day') &&
                                    preset.label === selection.preset
                                ) {
                                    document.querySelector(`.preset-option[data-preset="${preset.label}"]`).classList.add("active");
                                    selection.preset = preset.label;
                                    dateSelection.innerText = `${fromText} ${fromText !== '' ? preset.label.toLowerCase() : preset.label}`;
                                    selectingPreset = false;
                                }
                            })
                        } else {
                            let selectedPreset = document.querySelector('.preset-option.active');
                            if(selectedPreset) selectedPreset.classList.remove('active');
                            selection.preset = null;
                            dateSelection.innerText = `${fromText} ${selection.start.format('MMM DD, YYYY')} - ${selection.end.format('MMM DD, YYYY')}`;
                        }
                        
                        datepickerWrap.classList.remove('active');
                        onChange(selection);
                    }

                    selectDateLoopCounter++;
                },
            })
        }

        const set = (options) => {
            selectDateLoopCounter = 0;

            if(options.preset) {
                enablePreset(options.preset);
            } else {
                selection.start = moment(options.date[0]);
                selection.end = moment(options.date[1]);
                dateSelection.innerText = `${fromText} ${selection.start.format('MMM DD, YYYY')} - ${selection.end.format('MMM DD, YYYY')}`;
                backingComponent.selectDate([options.date[0], options.date[1]]);
            }
        }

        const reset = (context) => {
            // reset datepicker to default state
            enablePreset('Last 90 days');
        }

        const loadFromBrowserStorage = (prefix, nestedId) => {
            let params = browser_storage.getItem(`${prefix}-date-params`, nestedId);
            if(!params) return;
            
            params = JSON.parse(params);

            if( params.preset != null && 
                params.preset != 'undefined' && 
                params.preset != '' && 
                params.preset != 'null'
            ) {
                enablePreset(params.preset);
            } else if(params.date) {
                set(params);
            }
        }

        const saveToBrowserStorage = (prefix, nestedId) => {
            let params = {
                preset: selection.preset,
                date: [selection.start.format('YYYY-MM-DD'), selection.end.format('YYYY-MM-DD')]
            }

            browser_storage.setItem(prefix + '-date-params', JSON.stringify(params), nestedId);
        }

        const removeFromBrowserStorage = (prefix, nestedId) => {
            browser_storage.removeItem(prefix + '-date-params', nestedId);
        }

        return {
            set: set,
            create: create,
            reset: reset,
            loadFromBrowserStorage: loadFromBrowserStorage,
            saveToBrowserStorage: saveToBrowserStorage,
            removeFromBrowserStorage: removeFromBrowserStorage,
            getDateParams: function () {
                return {
                    preset: selection.preset,
                    date: [selection.start.format('YYYY-MM-DD'), selection.end.format('YYYY-MM-DD')]
                };
            },
            getStartDate: function () {
                return selection.start;
            },
            getEndDate: function () {
                return selection.end;
            },
            getPreset: function () {
                return selection.preset;
            }
        };
    }
);